import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Card } from "antd";

const PaymentSuccess = () => {
  const history = useHistory();
  return (
    <div className="payment-response-wrapper">
      <Card>
        <h1>Congratulations!</h1>
        <p>
          You have successfully subscribed <b>Professional</b> subscription. You
          can now access the Investors Search and Leads freely.
        </p>
        <Button
          type="primary"
          onClick={() => history.push("/dataset")}
          className="action-btn"
        >
          Continue
        </Button>
      </Card>
    </div>
  );
};
export default PaymentSuccess;
